import { Grid } from "@mui/material";
import { useMemo } from "react";
import ContentTitle from "../../../../components/Content/ContentTitle";
import { useLanguageContext } from "../../../../contexts/LanguageContext";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { INavigationLink } from "../../../../interfaces/INavigation";
import { useEnvironmentContext } from "../../../../contexts/EnvironmentContext";
import Iframe from "../../../../components/Iframe";
import Empty from "../../../../components/Empty";


const AnalyticalDashboard = (linkProps: INavigationLink) => {
    const { translate } = useLanguageContext();
    const { environment } = useEnvironmentContext();
    const { user, enterprise } = useAuthContext();


    const analyticalDashboardUrl = useMemo(() => {
        if (user && user.allowAllEnterprisesViewedInAnalyticalDashboard) {
            const analyticalDashboardUrl = environment.analyticalDashboardUrl;

            if (analyticalDashboardUrl && analyticalDashboardUrl.trim().length > 0) {
                return analyticalDashboardUrl;
            }
        }

        return enterprise?.analyticalDashboardUrl?.trim() ?? '';
    }, [user, environment, enterprise]);


    return (
        <>
            {
                analyticalDashboardUrl && analyticalDashboardUrl.length > 0 ? <>
                    <Iframe src={analyticalDashboardUrl} title={translate(linkProps.name)} className="position-absolute" />
                </> : <>
                    <Grid item xs={12} className='grid-header'>
                        <Grid item className='grid-title'>
                            <ContentTitle 
                                name={translate(linkProps.name)} 
                                description={enterprise?.name}
                                applyTranslation={false}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className='grid-content'>
                        <Grid item xs={12} className='paper-content display-flex alignitems-center justifycontent-center'>
                            <Empty text='noUrlConfiguredForPowerBiVisualization' />
                        </Grid>
                    </Grid>
                </>
            }
        </>
    );
}

export default AnalyticalDashboard;